"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const brandIcon_png_1 = __importDefault(require("../../assets/img/brandIcon.png"));
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-2d2c5048"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "header" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
    src: brandIcon_png_1.default,
    alt: ""
}, null, -1));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "rightContent" };
const index_vue_1 = __importDefault(require("./UserInfo/index.vue"));
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const toDictionaries = () => {
            router.push('/dictionaries');
        };
        return (_ctx, _cache) => {
            const _component_BookOutlined = (0, vue_2.resolveComponent)("BookOutlined");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", {
                    class: "brand",
                    onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(router).push('/')))
                }, _hoisted_3),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createVNode)(_component_BookOutlined, {
                        class: "data",
                        onClick: toDictionaries
                    }),
                    (0, vue_2.createVNode)(index_vue_1.default)
                ])
            ]));
        };
    }
});
